import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

export const DetailField = ({
  label,
  children,
  stacked = false,
}: {
  label: string;
  children: ReactNode;
  /** Label above the value — use inside a two-column facts grid. */
  stacked?: boolean;
}) => (
  <div
    className={cn(
      stacked
        ? 'flex min-w-0 flex-col gap-1'
        : 'grid gap-1 sm:grid-cols-[9rem_1fr] sm:items-start sm:gap-4',
    )}
  >
    <dt className="text-body-sm text-fg-secondary">{label}</dt>
    <dd className="text-body-sm text-fg">{children}</dd>
  </div>
);
